import {
  chatWithMeLink,
  type Credentials,
  generateTransferUrl,
} from "@alice-and-bot/core";
import { toast } from "react-hot-toast";
import { Button } from "./components.tsx";

export const InviteLink = (
  { publicSignKey }: { publicSignKey: string },
) => (
  <Button
    onClick={async () => {
      const link = await chatWithMeLink(
        publicSignKey,
      );
      await navigator.clipboard.writeText(link);
      toast.success("Chat link copied!");
    }}
  >
    Invite others to talk to bot
  </Button>
);

export const OpenWebChatButton = (
  { botPubKey, userCreds }: { botPubKey: string; userCreds: Credentials },
) => (
  <Button
    onClick={() => {
      const op = async () => {
        const link = await generateTransferUrl(userCreds, botPubKey);
        globalThis.open(link, "_blank");
      };
      toast.promise(op(), {
        loading: "Generating secure transfer link...",
        success: "Web chat opened!",
        error: "Failed to generate transfer link",
      });
    }}
  >
    Talk on Alice&Bot
  </Button>
);
